<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          Cargar Trazabilidad de Producto
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="8" sm="8" md="8">
              <v-text-field dense v-model="filtroproducto" @change="cargarproducto(filtroproducto)"
                label="Ingresar Ubicación">
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="1">
              <v-dialog v-model="dialogcamara" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on" @click="showCamera('1')">
                    Scan
                    <v-icon dark right>
                      mdi-camera
                    </v-icon>
                  </v-btn>
                </template>
                <div class="container">
                  <v-form ref="form" v-model="validcamara" :lazy-validation="lazycamara">
                    <v-card elevation="24" max-width="400" class="mx-auto" color="#00BB2D" dark raised>
                      <v-card-title class="headline layout justify-center">Lector de Código QR
                        <p class="error">{{ error }}</p>

                        <p class="decode-result">
                          Último resultado: <b>{{ result }}</b>
                        </p>
                      </v-card-title>
                      <v-container>
                        <v-row dense>
                          <v-col cols="12">
                            <StreamBarcodeReader v-if="isview" @close="onClosed" @decode="onDecode" @loaded="onLoaded">
                            </StreamBarcodeReader>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-form>
                </div>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="2">
              <h6>Serie: {{ serie }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Tipo: {{ tipo }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Modelo: {{ modelo }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Producto: {{ producto }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Función: {{ funcion }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Nombre: {{ nombre }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="2">
              <h6>Descripción: {{ descripcion }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>OT: {{ ot }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Nombre OT: {{ nombreot }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <h6>Fecha: {{ fecha }}</h6>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-data-table :headers="headers" :items="componentes" locale="es-ar" class="elevation-1" :items-per-page="10"
          :footer-props="{
              itemsPerPageText: 'Componentes por página',
            }">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Componentes</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="850px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    Agregar
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field autofocus v-model="editedItem.itemref" label="Recepción/Item"
                            @change="cargarcomponente(editedItem.itemref)"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field v-model="editedItem.idrecepcion" label="ID Recepción"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field v-model="editedItem.itemr" label="N° Recepción"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field v-model="editedItem.serie" label="Serie"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field v-model="editedItem.descrip" label="Detalle Material"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                          <v-text-field v-model="editedItem.observ" label="Observaciones"></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                          <v-dialog v-model="dialogcamara" width="500">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on" @click="showCamera('2')">
                                Scan
                                <v-icon dark right>
                                  mdi-camera
                                </v-icon>
                              </v-btn>
                            </template>
                            <div class="container">
                              <v-form ref="form" v-model="validcamara" :lazy-validation="lazycamara">
                                <v-card elevation="24" max-width="400" class="mx-auto" color="#00BB2D" dark raised>
                                  <v-card-title class="headline layout justify-center">Lector de Código QR
                                    <p class="error">{{ error }}</p>

                                    <p class="decode-result">
                                      Último resultado: <b>{{ result }}</b>
                                    </p>
                                  </v-card-title>
                                  <v-container>
                                    <v-row dense>
                                      <v-col cols="12">
                                        <StreamBarcodeReader v-if="isview" @close="onClosed" @decode="onDecode"
                                          @loaded="onLoaded"></StreamBarcodeReader>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card>
                              </v-form>
                            </div>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="purple" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small color="red" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>

      <v-card color="blue" dark tile>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.stop="guardartrazab">Guardar</v-btn>
          <!-- 
            <v-btn color="error" @click.stop="show = false">Salir</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../../src/axios-auth";
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  components: { StreamBarcodeReader },
  data: (vm) => ({
    validcamara: false,
    lazycamara: false,
    dialogcamara: false,
    result: "",
    error: "",
    isview: false,
    filtrar: "",
    editedItem: {},
    editedIndex: -1,
    filtroproducto: "",
    productos: [],
    componentes: [],
    trazab: [],
    serie: "",
    tipo: "",
    funcion: "",
    producto: "",
    modelo: "",
    nombre: "",
    descripcion: "",
    ot: "",
    nombreot: "",
    fecha: "",
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      itemref: "",
      serie: "",
      itemr: "",
      idrecepcion: "",
      descrip: "",
      observ: "",
    },
    defaultItem: {
      itemref: "",
      serie: "",
      itemr: "",
      idrecepcion: "",
      descrip: "",
      observ: "",
    },
    headers: [
      {
        text: "Serie",
        align: "start",
        sortable: false,
        value: "serie",
      },
      { text: "Recepción", value: "itemr" },
      { text: "ID Recepción", value: "idrecepcion" },
      { text: "Detalle", value: "descrip" },
      { text: "Observaciones", value: "observ" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    valid: false,
    lazy: false,
    mensaje: "",
  }),
  watch: {
    dialog(val) {
      val || this.close();
      console.log(this.valid);
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Componente" : "Editar Componente";
    },
    show: {
      get() {
        // this.cargarObras(false);
        this.$store.state.sector = "Inspeccion";
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    onClosed() {
      console.log("onClosed");
      this.isview = false;
    },
    showCamera(flag) {
      if (flag == "1") {
        this.filtrar = "1";
      }
      if (flag == "2") {
        this.filtrar = "2";
      }
      return (this.isview = !this.isview);
    },
    onDecode(result) {
      if (this.filtrar == "1") {
        console.log("FLAG1");
        this.filtroproducto = result;
        this.cargarproducto(result);
        this.onClosed;
      }
      if (this.filtrar == "2") {
        console.log("FLAG2");
        this.cargarcomponente(result);
        this.onClosed;
      }
      this.isview = false;
      this.dialogcamara = false;
    },
    onLoaded() {
      console.log("load");
    },
    cargarproducto(filtro) {
      let self = this;
      axios
        .get("/Producto/GetProducto", {
          params: {
            filtro: filtro,
          },
        })
        .then((response) => {
          self.serie = response.data[0].serie;
          self.tipo = response.data[0].tipo;
          self.modelo = response.data[0].modelo;
          self.producto = response.data[0].producto;
          self.funcion = response.data[0].funcion;
          self.nombre = response.data[0].nombre;
          self.descripcion = response.data[0].descripcion;
          self.ot = response.data[0].ot;
          self.nombreot = response.data[0].nombreot;
          self.fecha = response.data[0].fecha;
        })
        .catch((error) => {
          self.serie = [];
          self.tipo = [];
          self.modelo = [];
          self.producto = [];
          self.funcion = [];
          self.nombre = [];
          self.descripcion = [];
          self.ot = [];
          self.nombreot = [];
          self.fecha = [];
        });
    },
    cargarcomponente(filtro) {
      console.log("filtro: " + filtro)
      let self = this;
      axios
        .get("/Producto/GetComponente", {
          params: {
            filtro: filtro,
          },
        })
        .then((response) => {
          if (response.data[0].itemt == "0" || response.data[0].itemt == null) {
            self.editedItem.serie = response.data[0].serie;
            self.editedItem.descrip = response.data[0].descrip;
            self.editedItem.itemr = response.data[0].itemr;
            self.editedItem.idrecepcion = response.data[0].idrecepcion;
            self.editedItem.observ = response.data[0].observ;
            console.log(" item: " + self.editedItem.idrecepcion);
          } else {
            self.showAlert({
              icon: "error",
              title: "Componente ya utilizado en otra trazabilidad",
              timer: "3000",
              vm: self,
            });
          }
        })
        .catch((error) => {
          self.editedItem = [];
        });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },

    guardartrazab() {
      this.$swal({
        title: "Guardar Trazabilidad",
        text: "¿Desea guardar los datos de esta ubicación/producto?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.componentes.forEach((element) => {
            this.trazab.push({
              ot: this.ot,
              ubicacion: this.filtroproducto,
              serie: element.serie,
              itemr: element.itemr,
              observ: element.observ,
              idrecepcion: element.idrecepcion,
            });
          });

          var datostrazab = this.trazab;

          let self = this;
          console.log(datostrazab);
          axios
            .post("/Inspeccion/Guardartrazabilidad", datostrazab)
            .then((response) => {
              self.mensaje = response.data;
              // self.$refs.form.resetValidation();
              self.vaciarModels();
              self.showAlert({
                icon: "success",
                title: "Trazabilidad guardada con éxito - " + self.mensaje,
                timer: "3000",
                vm: self,
              });
              self.$emit("close");
            })
            .catch({});
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    vaciarModels() {
      this.filtroproducto = "";
      this.productos = [];
      this.componentes = [];
      this.trazab = [];
      this.serie = "";
      this.tipo = "";
      this.funcion = "";
      this.producto = "";
      this.modelo = "";
      this.nombre = "";
      this.descripcion = "";
      this.ot = "";
      this.nombreot = "";
      this.fecha = "";
    },
    editItem(item) {
      this.editedIndex = this.componentes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.componentes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.componentes.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.componentes[this.editedIndex], this.editedItem);
      } else {
        this.componentes.push(this.editedItem);
      }
      const eliminaDuplicados = (arr) => {
        const unicos = [];
        for (var indice = 0; indice < this.componentes.length; indice++) {
          const component = this.componentes[indice];
          let esDuplicado = false;
          for (var i = 0; i < unicos.length; i++) {
            if (unicos[i].serie === component.serie) {
              esDuplicado = true;
              break;
            }
          }

          if (!esDuplicado) {
            unicos.push(component);
          }
        }
        this.componentes = unicos;
        return unicos;
      };
      this.componentes = eliminaDuplicados(this.componentes);
      // console.log(unicos);
      this.close();
    },
  },
};
</script>
